import { MouseEvent, FC, useMemo } from 'react';
import { List, ListItemButton, Typography } from '@mui/material';
import isUndefined from 'lodash/isUndefined';

import { navigation } from '@shared/routes';
import { NavLink } from '@cvt/components/NavLink';
import { useDictionary } from '@cvt/hooks/useDictionary';
import { useRouter } from '@cvt/routing';
import { Authenticated, NotAuthenticated } from '@modules/Auth/components';
import { useBlockedNavigate } from '@cvt/contexts';


interface Props {

};

export const HeaderNav: React.FC<Props> = (props) => {
  const dictionary = useDictionary();
  const router = useRouter();

  const headerMenuRoutes = useMemo(() => {
    return navigation(router, dictionary).header || [];
  }, [dictionary, router]);

  const authIndependentRoutes = useMemo(() => {
    return headerMenuRoutes.filter(route =>  route.requiresAuth === undefined || route.requiresAuth === null);
  }, [headerMenuRoutes]);

  const authenticatedRoutes = useMemo(() => {
    return headerMenuRoutes.filter(route => !isUndefined(route.requiresAuth) && route.requiresAuth !== false);
  }, [headerMenuRoutes]);

  const notAuthenticatedRoutes = useMemo(() => {
    return headerMenuRoutes.filter(route => !isUndefined(route.requiresAuth) && route.requiresAuth === false);
  }, [headerMenuRoutes]);

  return (
    <List
      disablePadding sx={{
        flexDirection: 'row',
        alignItems: 'center',
        display: { xs: 'none', sm: 'flex' },
        gap: { xs: 0, sm: 1 },
      }}
    >
      {authIndependentRoutes.map((item, idx) => <NavItem key={idx} item={item}/>)}
      <Authenticated>
        {authenticatedRoutes.map((item, idx) => <NavItem key={idx} item={item}/>)}
      </Authenticated>
      <NotAuthenticated>
        {notAuthenticatedRoutes.map((item, idx) => <NavItem key={idx} item={item}/>)}
      </NotAuthenticated>
    </List>
  );
};

type NavItemProps = {
  item: CVT.Navigation.NavigationItem;
}

const NavItem: FC<NavItemProps> = ({ item }) => {
  const { icon, text, route, onClick, disabled } = item;
  const navigate = useBlockedNavigate();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    onClick?.();
    navigate(route!);
  };

  return (
    <ListItemButton
      color="text.secondary"
      component={NavLink}
      to={route!}
      onClick={handleClick}
      disabled={disabled}
      sx={{
        px: { xs: 1, sm: undefined },
      }}
    >
      {icon}
      <Typography variant="body1" fontSize={12} fontWeight={500} color="text.secondary" display="inline">
        {text}
      </Typography>
    </ListItemButton>
  );
};
